import { Box, Grid, Typography } from '@mui/material'

import HowItWorksGridBlock from '@ecm/ui/component/block/HowItWorksGridBlock'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

const HowItWorks = () => (
  <Box
    sx={{
      background: `linear-gradient(to top, ${Color.smoke.lightest} 40%, transparent 0)`,
    }}
  >
    <MainContainer sx={{ paddingBottom: '3em', paddingTop: { md: '10em', xs: '5em' } }}>
      <Grid container alignItems="center" direction="column" margin="0 0 3em">
        <Typography variant="h3" component="h2" maxWidth="15em">
          How Virtual Mail Works
        </Typography>
        <Anchor href="/virtual-mailbox" caret>
          Check the Virtual Mailbox details
        </Anchor>
      </Grid>
      <Box
        bgcolor={Color.white.normal}
        padding="5em 3em"
        sx={{ borderRadius: '16px', boxShadow: '0px 10px 20px 20px rgba(75, 79, 99, 0.05)' }}
      >
        <HowItWorksGridBlock alignCenter />
      </Box>
    </MainContainer>
  </Box>
)

export default HowItWorks
